import { useEffect } from 'react';

/**
 * Custom hook to handle clickaway events on the header element.
 * Native clickaway will not handle clicks inside the header due to style requirements,
 * therefore we handle header clickaway by this custom implementation.
 */
export function useHeaderClickaway(
  isOpen: boolean,
  handleCloseClick: () => void,
) {
  useEffect(() => {
    const headerEl = document.getElementById('header');

    if (isOpen) {
      headerEl?.addEventListener('pointerdown', handleCloseClick);
    } else {
      headerEl?.removeEventListener('pointerdown', handleCloseClick);
    }

    // Cleanup function to remove event listener when component unmounts
    return () => {
      headerEl?.removeEventListener('pointerdown', handleCloseClick);
    };
  }, [handleCloseClick, isOpen]);
}
